import { render } from "./OrderHeader.vue?vue&type=template&id=27073572&scoped=true"
import script from "./OrderHeader.vue?vue&type=script&lang=js"
export * from "./OrderHeader.vue?vue&type=script&lang=js"

import "./OrderHeader.vue?vue&type=style&index=0&id=27073572&scoped=true&lang=css"

import exportComponent from "/Users/dejth/Workspace/nakee-order-detail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27073572"]])

export default __exports__